export const HeaderConstants = {
  PracticeId: 'PracticeId',
  ClientId: 'ClientId',
  SupportAccessRequestId: 'SupportAccessRequestId',
  EntityId: 'EntityId'
};
